module.exports = __webpack_public_path__ + "static/media/sz.e8639cc9.svg";